/**
 * Toolbar button that shows and hides the docked Animations pane.
 *
 * Only the toggle lives here — the pane itself renders in MainLayout, next to the slide
 * canvas. The two are joined by `animationPaneOpen` in the slide store rather than by a
 * dropdown overlay, which is what keeps the pane from covering the slide.
 */

import React from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { slideAction } from '../../../store/slideSlice';
import classes from './AnimationsPaneTrigger.module.css';

export const AnimationsPaneTrigger = () => {
  const dispatch = useDispatch();
  const isReadOnly = useSelector((state) => state.slide.isReadOnly);
  const isOpen = useSelector((state) => state.slide.animationPaneOpen);

  return (
    <Tooltip
      overlayInnerStyle={{
        width: '60px', minHeight: '20px', fontSize: '10px', padding: '5px',
        textAlign: 'center', backgroundColor: 'black', lineHeight: '10px',
      }}
      placement="bottom"
      title="Animations"
    >
      <span
        className={`${classes.trigger} ${isOpen ? classes.triggerActive : ''}`}
        role="button"
        aria-pressed={isOpen}
        aria-label="Animations"
        // Never steal focus from the slide: blur deselects the object being animated.
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => { if (!isReadOnly) dispatch(slideAction.setAnimationPaneOpen(!isOpen)); }}
      >
        <AutoAwesomeMotionIcon style={{ fontSize: 20 }} />
      </span>
    </Tooltip>
  );
};

export default AnimationsPaneTrigger;
